@if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
  <div class="customize-fields__inner-container">
    <field-type-list-extended
      [field]="customizeFieldDate.dateLimitsConfig"
      [listValues]="customizeFieldDate.dateLimitsConfig.values"
      [preSelectItem]="customizeFieldDate.dateLimitsConfig.selectedLimitType"
      (itemSelected)="itemSelected($event, 'dateLockType')">
    </field-type-list-extended>
    <field-type-switch
      [field]="{label: 'customize.show-time'| afTranslate}"
      [small]="true"
      [preSelectItem]="customizeFieldDate.field.showTime"
      [disabled]="customizeFieldDate.field.noEditable || customizeFieldDate.disabledFormConfiguration"
      (itemSelected)="itemSelected($event, 'showTime')">
    </field-type-switch>
    <field-type-date
      [field]="customizeFieldDate.defaultValueInfo"
      [preSelectItem]="customizeFieldDate.field.defaultValue"
      (itemSelected)="itemSelected($event, 'defaultValue')">
    </field-type-date>
    <customize-fields-switch-form
      [field]="customizeFieldDate.field"
      [small]="true"
      [concept]="concept"
      [isPrivate]="isPrivate"
      [hiddenInLandings]="hiddenInLandings"
      [typeView]="typeView"
      [previewMode]="previewMode">
    </customize-fields-switch-form>
  </div>
}
